import { offsegBaseURL } from "../const/url";

/**
 * Offseg Webアプリのログインページに遷移する関数
 */
export const redirectToOffsegLoginPage = () => {
	window.open(`${offsegBaseURL}/login`, '_blank');
};

/**
 * Offseg Webアプリのトップページに遷移する関数
 */
export const redirectToOffsegTopPage = () => {
	window.open(`${offsegBaseURL}/top/top`, '_blank');
};

/**
 * Offseg Webアプリの現在位置/走行ルート/車両操作ページに遷移する関数
 */
export const redirectToOffsegCurrentLocationPage = () => {
	window.open(`${offsegBaseURL}/vehicle/current-location-driving-route`, '_blank');
};

/**
 * Offseg Webアプリのドライバー/車両日報ページに遷移する関数
 */
export const redirectToOffsegDailyReportPage = () => {
	window.open(`${offsegBaseURL}/business/daily-report`, '_blank');
};

/**
 * Offseg Webアプリのイベント映像一覧ページに遷移する関数
 */
export const redirectToOffsegEventVideoListPage = () => {
	window.open(`${offsegBaseURL}/video-data/event-video-list`, '_blank');
};